import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filters: {},
    lastTab: 0
}

export const k8DashboardSlice = createSlice({
    "name": "Dashboard",
    initialState,
    reducers: {
        setDashboardState: (state, action) => {
            state.filters[action.payload.key] = action.payload.obj
            state.lastTab = action.payload.tab
        },
        resetDashboardState: (state, action) => {
            state.filters = {};
            state.lastTab = 0;
        },

    }
})

export const { setDashboardState, resetDashboardState } = k8DashboardSlice.actions;

export default k8DashboardSlice.reducer;